import styled from "styled-components";

export const Container = styled("div")`
  display: flex;
`;

export const Temp = styled.div.withConfig({
  shouldForwardProp: (prop) => !["temperature", "selected"].includes(prop),
})<{
  temperature: "Frio" | "Morno" | "Quente";
  selected?: boolean;
}>`
  border-radius: 50%;
  display: flex;
  justify-content: center;
  width: 25px;
  background-color: ${({ temperature }) => {
    switch (temperature) {
      case "Frio":
        return "#2C80E2";
      case "Morno":
        return "#F5D153";
      case "Quente":
        return "#E55C5C";
      default:
        return "#FFFFFF";
    }
  }};
  color: white;
  border: none;
  margin: 0 1px;
  cursor: pointer;
  opacity: ${({ selected }) => (selected ? 1 : 0.2)};
  transition: opacity 200ms ease-in-out;

  svg {
    opacity: 0;
    fill: #f1f1f1;
    width: 12px;
    transition: opacity 200ms ease-in-out;
  }

  &:hover {
    svg {
      opacity: ${({ selected }) => (selected ? 1 : 0)};
    }
    opacity: 0.9;
  }
`;
